// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-menu-arrow {
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/AppSelectorMenu/AppMenuArrow.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF","sourcesContent":[".app-menu-arrow {\r\n  font-size: 18px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
